import dynamic from 'next/dynamic'
import type {Block} from '@/services/kontent-ai/types'
import type {ClickToBuySingleProductContentItem} from '@/products/where-to-buy/click2cart/click-to-buy-single-product/click-to-buy-single-product'

const ClickToBuySingleProductComponent = dynamic(
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error -- Necessary to fix build
	// @ts-ignore -- Necessary to fix build
	() =>
		import('./click-to-buy-single-product').then(
			(mod) => mod.ClickToBuySingleComponent
		),
	{
		ssr: false,
	}
)

export const ClickToBuySingleProductBlock: Block<
	ClickToBuySingleProductContentItem
> = (props) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error -- Necessary to fix build
	// @ts-ignore -- Necessary to fix build
	return <ClickToBuySingleProductComponent {...props} />
}
